export default "__VITE_ASSET__DSbuUINs__"